import {apiGetCashierTransactions} from "api/reportApi";

import {PriceComponent} from "components/Table/CellComponents";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "../helpers/DrawerActions";

const cashierTransactionsColumns = [
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    // {
    //   name: "شماره",
    //   key: "accountingCode",
    //   filterParams: {
    //     column: "accountingCode",
    //     columnType: "string",
    //   },
    // },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: (item: any) => true,
        onClick: (dispatch: any, item: any) => {
            if (item.type && item.type_id) {
                if (item.type === "factor") {
                    openFactorDrawer(dispatch, item);
                } else if (item.type === "transaction") {
                    openTransactionDrawer(dispatch, item);
                } else if (item.type === "transfer") {
                    openTransferDrawer(dispatch, item);
                } else if (item.type === "bill") {
                    openRemittanceDrawer(dispatch, item);
                }
            } else {
                openAccountingDrawer(dispatch, item);
            }
        },
    },
    {
        name: "بدهکار",
        key: "debtor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return !item.isCreditor ? item.amount?.toString() : "-";
        },
        Component: PriceComponent,
        filterParams: {
            column: "debtor",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "بستانکار",
        key: "creditor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return item.isCreditor ? item.amount?.toString() : "-";
        },
        Component: PriceComponent,
        filterParams: {
            column: "creditor",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "تراز",
        // @ts-ignore
        // getValue: (item: any, all: any[]) => {
        //     let key = 0;
        //     let balance = 0;
        //     const index = all?.findIndex((object) => object.id === item.id);
        //     while (key <= index) {
        //         const currentItem = all[key];
        //         balance += currentItem.isCreditor ? currentItem.amount : 0;
        //         balance -= !currentItem.isCreditor ? currentItem.amount : 0;
        //         key += 1;
        //     }
        //     return Math.abs(balance);
        // },
        colored:true,
        key: "balance",
        Component: PriceComponent,
        searchType: "quantitative",
        disableSearch: true,
    },
    {
        name: "تشخیص",
        // @ts-ignore
        // getValue: (item: any, all: any[]) => {
        //     // let key = 0;
        //     // let balance = 0;
        //     // const index = all?.findIndex((object) => object.description === item.description);
        //     // while (key <= index) {
        //     //     const currentItem = all[key];
        //     //     balance += currentItem.isCreditor ? currentItem.amount : 0;
        //     //     balance -= !currentItem.isCreditor ? currentItem.amount : 0;
        //     //     key += 1;
        //     // }
        //     return item.balance > 0 ? "بس" : item.balance < 0 ? "بد" : "-";
        // },
        key: "status",
        disableSearch: true,
    },
];

export const CashierTransactionsIndexData = [
    {
        key: "cashierTransactions",
        label: "گردش حساب صندوق",
        pluralLabel: "گردش حساب صندوق",
        disableSearch: true,
        title: "گردش حساب صندوق",
        pageTitle: "گردش حساب صندوق",
        // pageDescription: "گردش حساب و اسناد حسابداری مربوط به صندوق ها",
        tableColumns: cashierTransactionsColumns,
        actions: {
            back: {},
            fetch: apiGetCashierTransactions,
            // excel: {},
        },
    },
];
